import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

interface ScVipBenefitsProps {
  slidesNumber: number;
}

export const ScVipBenefits = styled.div<ScVipBenefitsProps>`
  width: 100%;
  position: relative;
  max-width: 392px;
  height: 156px;
  overflow: hidden;

  .wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    height: 100px;
    text-align: center;
    align-items: start;
    position: relative;
  }

  .items {
    width: 122px;
  }

  &.en,
  &.en-CA {
    .items:last-child {
      width: 67px;
      margin: 0 auto;
    }
  }

  .img {
    width: 56px;
    height: 56px;
  }

  .description {
    text-align: center;
    font-family: 'Open Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: ${({ theme }) => theme.whiteColor};
  }

  .title {
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 12px;
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    line-height: 24px;
    letter-spacing: 0.16px;
    font-style: normal;
  }

  .title-dynamic {
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
  }

  .swiper {
    height: 156px;
    align-items: flex-start;
    display: flex;
    position: relative;
  }

  .swiper-pagination {
    position: absolute;
    transform: translateX(-50%);
    top: unset;
    bottom: 0px;
    left: 50%;
    z-index: 20;
    gap: 4px;
    width: 132px;
    display: grid;
    grid-template-columns: ${({ slidesNumber }) =>
      `repeat(${slidesNumber}, 1fr)`};
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    &:before {
      position: relative;
      content: '';
      width: 100%;
      height: 8px;
      display: block;
      border-radius: 2px;
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    }

    @media (hover: hover) {
      &:hover {
        &:before {
          background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
        }
      }
    }

    &-active {
      &:before {
        background-color: ${({ theme }) => theme.whiteColor};
      }

      @media (hover: hover) {
        &:hover {
          &:before {
            background: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }
  }

  @media (${device.mobile}) {
    max-width: 368px;
    .items {
      width: 109px;
    }
  }
`;
